export enum Roles {
  GENERAL_CONTRACTOR = 1,
  TRUCKER = 2,
  COMPANY_ADMINISTRATOR = 3,
  COMPANY_SUPERUSER = 4,
  COMPANY_USER = 5,
  INDIVIDUAL = 6,
  SUPER_ADMIN = 7
}
